"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUTHORIZE_PAYMENT_NOTIFICATION_TYPE = void 0;
const PAYMENT_AUTHORIZATION = 'net.authorize.payment.authorization.created';
const PAYMENT_AUTH_CAPTURE = 'net.authorize.payment.authcapture.created';
const PAYMENT_CAPTURE = 'net.authorize.payment.capture.created';
const PAYMENT_PRIOR_AUTH_CAPTURE = 'net.authorize.payment.priorAuthCapture.created';
const PAYMENT_REFUND = 'net.authorize.payment.refund.created';
const PAYMENT_VOID = 'net.authorize.payment.void.created';
exports.AUTHORIZE_PAYMENT_NOTIFICATION_TYPE = {
    PAYMENT_AUTHORIZATION,
    PAYMENT_AUTH_CAPTURE,
    PAYMENT_CAPTURE,
    PAYMENT_PRIOR_AUTH_CAPTURE,
    PAYMENT_REFUND,
    PAYMENT_VOID
};
//# sourceMappingURL=authorizePaymentNotificationType.js.map